import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './BusinessInviteNeighbor.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import { Link,useNavigate } from 'react-router-dom';
import { gettoastsuccess } from '../../../Utils/Common';

const BusinessInviteNeighbor = () => {
 const navigate = useNavigate();
    useEffect(() => {
        document.title = `Business Invite Neighbor | Local Bells`;
        document.getElementById('bodywrap').className = 'busiian';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const handleCopy = () => {
        const url = process.env.REACT_APP_BASE_URL;
        navigator.clipboard.writeText(url)
            .then(() => {
                gettoastsuccess('Link copied to clipboard', '');
            })
            .catch(err => {
                console.error('Failed to copy:', err);
            });
    }

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible}/>
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='ian-box'>
                                    <Row className='mx-0'>
                                        <Col md={12} lg={12} xl={8} xxl={6} className='white-box'>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>Share LocalBells with your neighborhood!</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            <h6>Use the link below to invite neighbors and help grow your local community.</h6>
                                            <Form>
                                                <Row>
                                                    <Col xs={12} sm>
                                                        <Form.Group>
                                                            <Form.Control className='gen-input' type="text" placeholder="Subject" value={process.env.REACT_APP_BASE_URL} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} sm="auto">
                                                        <Button type="Button" className='blue-btn' onClick={handleCopy}>Copy invite link</Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                            <div>
                                                <h6>Or share via:</h6>
                                                <div>
                                                    <Link to="#" onClick={handleCopy}>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/whatsapp.webp'} className="img-fluid np-icn" alt="whatsapp" />
                                                    </Link>
                                                    <Link to="#" onClick={handleCopy}>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/mail.webp'} className="img-fluid np-icn" alt="mail" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='footer-org footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default BusinessInviteNeighbor;


